import Vue from "vue";
import utils from "@utils/index.js";

Vue.prototype.$utils = utils;
